import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import classNames from 'classnames';
import NavigationLinks from '@cotyorg/ccx-molecules/NavigationLinks';
import CountrySelectorButton from '@cotyorg/ccx-organism-country-selector/CountrySelectorButton';
import CountrySelector from '@cotyorg/ccx-organism-country-selector/CountrySelector';
import BBCodeParser from '@cotyorg/ccx-utils/js/components/BBCodeParser';


const Copyright = ({
  text,
  pages,
  countrySelector,
  extraClass,
  showPages,
  isServedFromLegacySite,
}) => {
  const copyrightClasses = classNames(
    'copyright',
    'flex-container',
    extraClass,
  );
  const copyrightPages = R.pathOr([], [0, 'pages'])(pages);
  const countrySelectorVisible = R.prop('visible')(countrySelector);
  const countrySelectorPadding = R.prop('padding')(countrySelector);
  const countrySelectorBeforeCopyright = R.prop('beforeCopyright')(countrySelector);
  const countrySelectorShowToggleIcon = R.prop('showToggleIcon')(countrySelector);

  return (
    <div className="footer__copyright">
      <div className="grid-container">
        <div className={copyrightClasses}>
          {showPages && copyrightPages && (
            <nav className="copyright__nav">
              <ul className="copyright__nav-ul">
                <NavigationLinks
                  pages={copyrightPages}
                  extraClass="copyright__nav-li"
                  linkExtraClass="copyright__nav-link"
                  titleExtraClass="copyright__nav-title"
                  disableNesting
                />
              </ul>
            </nav>
          )}
          {countrySelectorVisible && (
            <div className="footer-country-expansion__country-selector">
              <CountrySelectorButton
                extraClass="footer-country-expansion__country-selector-button"
                showToggleIcon={countrySelectorShowToggleIcon}
              />
            </div>
          )}
          {!countrySelectorBeforeCopyright && (
            <small className="copyright__message">
              <BBCodeParser>{text}</BBCodeParser>
            </small>
          )}
        </div>
      </div>
      {countrySelectorVisible && (
        <CountrySelector
          padding={countrySelectorPadding}
          isServedFromLegacySite={isServedFromLegacySite}
        />
      )}
      {countrySelectorBeforeCopyright && (
        <small className="copyright__message">
          <BBCodeParser>{text}</BBCodeParser>
        </small>
      )}
    </div>
  );
};

Copyright.propTypes = {
  text: PropTypes.string.isRequired,
  countrySelector: PropTypes.shape({
    visible: PropTypes.bool,
    padding: PropTypes.bool,
    beforeCopyright: PropTypes.bool,
    showToggleIcon: PropTypes.bool,
  }),
  pages: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
    pages: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      pages: PropTypes.array,
    })),
  })),
  extraClass: PropTypes.string,
  showPages: PropTypes.bool,
  isServedFromLegacySite: PropTypes.bool,
};

export default Copyright;
